import { getQueryString } from '#utils/parseUrl';
import api from '#config/api';

export const getEvents = data => api.get(`/events${getQueryString(data)}`);
export const postEvent = data => api.post('/events', data);
export const editEvent = ({ id, ...data }) => api.put(`/events/${id}`, data);
export const deleteEvent = id => api.delete(`/events/${id}`);
